import { useState } from "react";
import { api, BACKEND_URL } from "@/lib/api";
import { toast } from "sonner";
import { Bell, BellOff, Zap } from "lucide-react";

function urlB64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding).replace(/-/g, "+").replace(/_/g, "/");
  const raw = atob(base64);
  return new Uint8Array([...raw].map(c => c.charCodeAt(0)));
}

export default function PushSubscribeCard() {
  const [status, setStatus] = useState(typeof Notification !== "undefined" ? Notification.permission : "denied");
  const [loading, setLoading] = useState(false);

  const subscribe = async () => {
    if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
      toast.error("Notifications non supportées par ce navigateur");
      return;
    }
    setLoading(true);
    try {
      const reg = await navigator.serviceWorker.register("/sw.js");
      await navigator.serviceWorker.ready;
      const perm = await Notification.requestPermission();
      setStatus(perm);
      if (perm !== "granted") { toast.error("Permission refusée"); return; }
      const vapidRes = await fetch(`${BACKEND_URL}/api/push/vapid-public-key`);
      const { key } = await vapidRes.json();
      const sub = await reg.pushManager.subscribe({
        userVisibleOnly: true,
        applicationServerKey: urlB64ToUint8Array(key),
      });
      await api.post("/push/subscribe", { subscription: sub.toJSON() });
      toast.success("Notifications activées ✓");
    } catch (e) {
      console.error("push subscribe", e);
      toast.error("Erreur d'activation");
    } finally { setLoading(false); }
  };

  const testPush = async () => {
    try { const r = await api.post("/push/test"); toast.success(`Push envoyé (${r.data.sent}/${r.data.total})`); }
    catch { toast.error("Erreur"); }
  };

  return (
    <section className="glass-strong rounded-2xl p-6">
      <h2 className="font-display text-lg font-bold flex items-center gap-2"><Bell size={16} className="text-[#F59E0B]"/> Notifications</h2>
      <p className="mt-2 text-sm text-slate-400">Recevez une alerte push dès qu'un nouveau trajet correspond à une de vos recherches sauvegardées.</p>
      <div className="mt-3 flex flex-wrap gap-2">
        {status === "granted" ? (
          <>
            <span data-testid="push-status" className="inline-flex items-center gap-1 text-xs text-emerald-400 px-3 py-2"><Bell size={12}/> Activées</span>
            <button data-testid="push-test" onClick={testPush} className="btn-ghost-glass px-3 py-2 rounded-lg text-xs flex items-center gap-1"><Zap size={12}/> Envoyer un test</button>
          </>
        ) : (
          <button data-testid="push-subscribe" onClick={subscribe} disabled={loading} className="btn-coral px-4 py-2 rounded-lg text-sm flex items-center gap-2"><BellOff size={14}/> Activer les notifications</button>
        )}
      </div>
    </section>
  );
}
